var mod = function mod(n, m) {
  return (n % m + m) % m;
};

module.exports = mod;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/mod.js
// module id = 70
// module chunks = 0 1 2